import headerCarouselImg from '@/assets/images/home/home-header-image-original.png';
import headerCarouselImg2 from '@/assets/images/home/home-header-image-2.png';
export default {
  homeView: {
    title: '<span style="color: #A31C25;">Discover</span> and <span style="color: #A31C25;">find</span> products according to your preferences',
    headerCarousel: {
      printListIp: 'Print the IP list',
      printListSaq: 'Print the SAQ list',
      exploreAgencyProduct: "Explore the agency's products",
    },
    productCarousel: {
      allProducts: 'All products',
    },
    blogVideosCarousel: {
      title: 'videos',
      allVideosLink: 'All videos',
    },
    blogVideo1Carousel: {
      title: 'boires in importation prive...',
      description: 'what is i\'ip',
    },
    blogVideo2Carousel: {
      title: 'Drinks on the tablets',
      description: 'Renaissance, Champagne 1st Cru Cumieres de Vadin-Plateau',
    },
    blogVideo3Carousel: {
      title: 'Drinks on the tablets',
      description: 'PB of Alta Allella',
    },
    blogsCarousel: {
      title: 'blog',
      title1: 'blogs',
      allBlogsLink: 'All blogs',
    },
    becomeMember: {
      title: 'Become member',
      content: 'A member has access to privileged wine allocations, customized advice, preferential pricing, tastings by appointment and much more.',
    },
    discoveryPackages: {
      title: 'Discovery packages',
      content: 'Monthly delivery of a discovery case containing 6 different bottles. Several packages are available and you can choose the one that suits you.'
        + ' Long live discovery, long live organic wines!',
    },
    infoRegisterForm: {
      title: 'info',
      subTitle: 'Stay informed of our offers and latest news',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      cta: 'Register',
    },
    cta: {
      readMore: 'Read more',
    },
    blogCarouselStatic: {
      title: 'THE PUNK VINEYARD OF THE JURA',
      subTitle: 'Didier Grappe',
      content: 'Didier Grappe produces terroir wines with vinification without inputs in order to produce wines that express the quintessence of the place.'
    },
    ProductCarouselSection: {
      ValentineDay: 'Valentine\'s Day',
      NewArrivals: 'New arrivals',
      InStore: 'In Store',
    }
  },
  headerCarousel: [
    {
      title: 'LET\'S RAISE OUR <span style="color: #A31C25;">GLASS</span> TO THOSE WHO tend THE <span style="color: #A31C25;">VINES</span>',
      image: headerCarouselImg,
      btn1: 'Print IP list',
      btnLink1: '',
      btn2: 'Print SAQ list',
      btnLink2: '',
      btn3: "Explore agency products",
      btnLink3: "/products",
    },
    { 
      title: 'OUR <span style="color: #A31C25;">SHOP</span>  for bites or private dining events',
      image: headerCarouselImg2,
      btn1: 'Montreal',
      btnLink1: 'products?inventory=STORE_MTL',
      btn2: 'Quebec',
      btnLink2: 'products?inventory=STORE_QC',
      btn3: "Toronto",
      btnLink3: "products?inventory=STORE_TORONTO",
    }
  ],
  cookiesModal: {
    title: 'Welcome to Boires',
    p1: 'This website is designated',
    p2: 'for people of legal drinking age.',
    p3: 'By purchasing on this site,',
    p4: 'you guarantee you are over 18 years old.',
    submit: 'Agree & Continue',
    remember: 'Remember me',
    denyMessage: 'See you soon! Come back when you are of legal drinking age'
  },
  cookiesModalOn: {
    title: 'Welcome to Boires',
    p1: 'This website is designated',
    p2: 'for people of legal drinking age.',
    p3: 'By purchasing on this site,',
    p4: ' you guarantee you are over 19 years old.',
    submit: 'Agree & Continue',
    remember: 'Remember me'
  },
  newsletter: {
    title: 'BOIRES ONTARIO NEWSLETTER',
    title1: 'Stay in the loop for all wine updates and events',
    titleQC: 'Stay tuned for our next arrivals!',
    provincePlaceholder: 'Province',
    iLike: 'I would like to know about',
    subscribe: 'Subscribe',
    cancel: 'Cancel',
    Qcop1: 'Arrivals at SAQ',
    Qcop2: 'IP arrivals',
    Qcop3: 'Our Events',
    Qcop4: 'Our Shop',
    OnOp1: 'Private Orders',
    OnOp2: 'Events',
    OnOp3: 'Our Shop',
    OnOp4: 'LCBO',
    success: 'Thank you for subscribing!',
    info: 'You are already subscribed!',
    errormsg: 'An error occurred. Please try again.',
  },
  provinceModalQc: 'You are browsing the interface of the Boires website, for the province of Quebec',
  provinceModalOn: 'You are browsing the interface of the Boires website, for the province of Ontario'
};
